import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import Switch from '@shared/components/forms/inputs/switch/switch.vue';
@Component({
  name: 'bc-impact-on-subscriptions-modal',
  components: {
    'bpc-switch': Switch,
  },
})
export default class ImpactOnSubscriptionsModal extends Vue {
  // PROPS
  @Prop({ type: Boolean }) readonly value: boolean;
  isProcessing = false;
  updateSubscriptions = true;
  get tenantId(): number {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  // LIFECYCLE

  // METHODS

  public get confirmButtonText() {
    if (this.updateSubscriptions) {
      return this.$t('subscriptions.subscription_categories.impact.impact_button');
    } else {
      return this.$t('subscriptions.subscription_categories.impact.do_not_impact_button');
    }
  }

  get showModal(): boolean {
    return this.value;
  }
  set showModal(val: boolean) {
    this.$emit('input', val);
  }
  closeModal() {
    this.showModal = false;
  }

  emitUpdateSubscriptions() {
    this.$emit('update-subscriptions', this.updateSubscriptions);
    this.closeModal();
  }

  resetModal() {
    //To be implemented
  }

  // WATCHERS
  @Watch('showModal')
  onShowModalChange(val) {
    if (val) {
      this.resetModal();
    }
  }
}
